import { Skeleton } from 'primereact/skeleton';
import "./style.css"

export const Option = ({loadingOptions}) =>{
        return (
            <div className="select_option" style={{ height: '40px' }}>
                <Skeleton className='optionSkeleton' width={loadingOptions.even ? '70%' : '60%'} />
            </div>
        );
}